/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface McpConsentRedirectResponse
 */
export interface McpConsentRedirectResponse {
    /**
     * 
     * @type {string}
     * @memberof McpConsentRedirectResponse
     */
    redirectUri: string;
}

/**
 * Check if a given object implements the McpConsentRedirectResponse interface.
 */
export function instanceOfMcpConsentRedirectResponse(value: object): value is McpConsentRedirectResponse {
    if (!('redirectUri' in value) || value['redirectUri'] === undefined) return false;
    return true;
}

export function McpConsentRedirectResponseFromJSON(json: any): McpConsentRedirectResponse {
    return McpConsentRedirectResponseFromJSONTyped(json, false);
}

export function McpConsentRedirectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): McpConsentRedirectResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectUri': json['redirectUri'],
    };
}

export function McpConsentRedirectResponseToJSON(json: any): McpConsentRedirectResponse {
    return McpConsentRedirectResponseToJSONTyped(json, false);
}

export function McpConsentRedirectResponseToJSONTyped(value?: McpConsentRedirectResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redirectUri': value['redirectUri'],
    };
}

